module.exports = __webpack_public_path__ + "img/data_one.f862e86c.png";